var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
			return $owl;
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});

		$('.icon.svg').each(function() {
			let icon = $(this).data('icon');
			if (icon && icon.length) {
				let style = "url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;";
				$(this).attr('style', "-webkit-mask: " + style + "mask: " + style);
			}
		});
	}
};


site.frontpage = {
	init: function() {
		var $decoration = $('.custom-banner .decoration').clone();
		$('.boxTitle', '.box.feedback').before($decoration);

		site.maxHeight.init('#moya_form_hvad-ma-betur-fara-i-isafjardarbae fieldset:nth-of-type(2)');

		$('.feedback input[type=radio]').each(function() {
			$(this).parent().before(this);
		});


		site.frontpage.mobileMenu();

		$('input', '#moya_form_hvad-ma-betur-fara-i-isafjardarbae fieldset:nth-of-type(1)').on('click', function(e) {

			var $this = $(this),
				$form = $this.closest('form');

			if ($this.is(':checked')) {

				if (!$this.hasClass('open')) {
					$form.addClass('open');
				}
				else {
					$form.removeClass('open');
					$this.removeAttr('checked');
				}
			}
			else {
				$form.removeClass('open');
			}

			$this.toggleClass('open');
			$this.siblings().removeClass('open');
		});

		$('input', '#moya_form_hvad-ma-betur-fara-i-isafjardarbae fieldset:nth-of-type(1)').keypress(function(e) {
			var key = e.which,
				$this = $(this);
			if (key === 13) {
				$this.closest('form').toggleClass('open');
				return false;
			}
		});

		site.frontpage.newsCarousel();
		$(window).resize(function() {
			site.frontpage.newsCarousel();
		});
	},

	hasCarousel: false,
	owl: null,

	newsCarousel: function() {
		var $body = $('body');
		if ($body.width() + 15 < 992) {

			if (!site.frontpage.hasCarousel) {
				site.frontpage.owl = site.owl.init('.news.cat-1', {
					responsive: {
						0: {
							items: 1,
						},
						480: {
							items: 2,
						}
					},
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				site.frontpage.owl.owlCarousel('destroy');
				$('.news.cat-1').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	},

	mobileMenu: function() {
		var $body = $('body');
		$('.level1 > a', '#mainmenu').on('click', function(e) {
			if ($body.width() < 991) {
				e.preventDefault();
				var $this = $(this);
				var className = $this.closest('li').attr('class').split(' ')[0];
				$('.' + className + ' > a', '#mMenu').trigger('click');
				$('#mainmenuToggle').trigger('click');
			}
		});
	}
};

site.decoration = {
	megamenu: function() {
		$('.megamenu').prepend('<div class="decoration"><div><span></span><span></span><span></span><span></span></div></div>');
	}
};

site.search = {
	checkboXLikeRadioButtons: function() {
		const searchForm = document.querySelector('#search #searchForm');
		if (!searchForm) {
			return;
		}
		searchForm.querySelectorAll('.elm_multiCheckbox input').forEach(function(input) {
			input.addEventListener('click', function(evt) {
				evt.preventDefault();
				let isChecked = this.checked;
				this.closest('form').querySelectorAll('input').forEach(function(otherInput) {
					if (otherInput !== input) {
						otherInput.checked = false;
					}
				});
				this.checked = isChecked;
				this.closest('form').submit();
			});
		})
	}
};

site.service = {
	init: function () {
		var $items = $('.items', '#extras .hasFilter');

		$('a', '#itemFilter').on('click', function () {
			var val = $(this).attr('data-filter');
			var scrollTop = $(window).scrollTop();
			location.hash = val;
			window.scrollTo(0, scrollTop);
		});

		$(window).load(function () {
			var $container = $items;
			$container.isotope({
				// options
				itemSelector: '.item',
				layoutMode: 'vertical',
				hiddenStyle: {
					opacity: 0
				},
				visibleStyle: {
					opacity: 1
				}
			});

			$container.addClass('loaded');
		});

		$(function () {
			$(window).bind("hashchange", function (e) {
				var b = location.hash;
				b = (b === '') ? '#all' : b;

				if (b) {
					b = b.substr(1, b.length);
					var filterValue = (b == 'all') ? '*' : '.' + b;
					var $container = $items;
					$container.isotope({filter: filterValue});
					$('#itemFilter a').removeClass('selected');
					$("#itemFilter ." + b).addClass('selected');
				}
			});
			$(window).trigger("hashchange");
		});
	}
};

site.qn = {
	init: function() {
		var $body = $('body');
		function processQnChildren(selector) {
			var $qnChildren = $(selector);
			$('.level2 a', $qnChildren).each(function() {
				$(this).html($(this).html().replace(' | ', '</span><span>'));
			});
			$('.mmLevel2', $qnChildren).removeClass('hide');
			//site.maxHeight.init('#qn-5 .mmLevel2');

			if ($body.width() + 15 >= 992) {
				$('> a', $qnChildren).on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					$(this).closest('li').toggleClass('open');

					$('body').toggleClass('qn-open');

					$('body.qn-open').on('click', function (e) {
						site.qn.close();
					});
				});
			}
		}

		processQnChildren('#qn-5 .children');
		processQnChildren('#frontTop-5 .children');






		// var $qnNext = $('.qn.children').next();
		// $qnNext.find('a').on('focus', function(e) {
		//     if ($body.hasClass('qn-open')) {
		//        site.qn.close();
		//     }
		// });

		$(document).keydown(function (e) {
			if (e.which === 27 && $body.hasClass('qn-open')) {
				site.qn.close();
				var $level1 = $(e.target).closest('.level1');
				$('> a', $level1).focus();
			}
		});

		site.qn.appendQuickNav();
	},

	appendQuickNav: function () {
		var $qn = $('#qn');
		var $menu = $('.mm-listview', '#mm-1');
		var $qnContent = '';

		$qn.find('li.level1').each(function () {
			var classes = $(this).attr('class');
			$qnContent += '<li class="qn ' + classes + '">' + $(this).clone().html() + '</li>';
		});
		$menu.append($qnContent);
		$('.qn .mmLevel2', $menu).removeAttr('id');
	},

	close: function() {
		$('.open', '#qn').removeClass('open');
		$('body').removeClass('qn-open');
	}
};

site.dropdown = {
	init: function () {
		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('.boxText','.main__categories').on('click', function(e) {
			e.stopPropagation();
		});

		$('.boxTitle a', '.main__categories').attr('href', '#').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$body = $('body'),
				$box = $this.closest('.box');

			if (!$box.hasClass('open')) {
				$box.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				site.dropdown.close();
			}
		});

		$('body').on('click', function () {
			if ($('body').is('.dropdown-open')) {
				site.dropdown.close();
			}
		});
	},

	setHeight:function() {
		var $dropdown = $('.boxText ul', '.main__categories');
		$($dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	close:function() {
		$('.box','.main__categories').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.megamenu.init();
	site.accessibility.init();
	site.qn.init();
	site.svg.init();
	site.sideContent.init();
	site.search.checkboXLikeRadioButtons();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.dropdown.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$('.share').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
